import {
  ALL_CHART_TYPES,
  DEFAULT_NORMALIZE_BY,
  DEFAULT_NORMALIZE_BY_SETTING
} from "constants/chart.constants";
import { CalculationMethod, EvaSource, TimeStep } from "constants/charts.enums";
import { createMergeWithDefaults } from "entities/utils";
import { TrendDateChartRequestType, TrendDateChartSettings } from "types";

import { MaxBinsSortOrderEnum } from "models/binSize";
import { EntityKind } from "models/entityKind";
import { PdenSourceEnum } from "models/pdenDataSourceSetting";

import { BASE_CHART_REQUEST } from "./defaults";

export const DEFAULT_TREND_DATE_MIDSTREAM_CHART_SETTINGS: Partial<TrendDateChartSettings> =
  {
    product: "Gas Inlet",
    otherProducts: [],
    chartType: ALL_CHART_TYPES.TrendDate.id,
    showForecast: false,
    showWellCount: true,
    pdenDataSourceSetting: {
      source: EvaSource.Public,
      timeStep: TimeStep.Month
    },
    forecastMode: "forecastTrump",
    useForecastStartDate: false,
    survivorBias: true,
    rateType: 0,
    cutoff: 50,
    timeStep: TimeStep.Month,
    shutInMonths: 3,
    source: EvaSource.Public,
    normalizeBy: DEFAULT_NORMALIZE_BY,
    useWeightedRatioAverage: true,
    xVariable: {
      valueProperty: "Header.FacilityStartDate_YearMonth",
      displayTitle: "Start Date (Year-Month)",
      canBin: false,
      dataType: "Text",
      mappingName: "Header.FacilityStartDate_YearMonth",
      bin: null,
      pdenSource: PdenSourceEnum.Public.toString()
    },
    yVariable: {
      valueProperty: "Performance.Gas.CurrentCalRate",
      displayTitle: "Current Cal. Rate (Mcf/d)",
      canBin: true,
      dataType: "Number",
      mappingName: "Performance.Gas.CurrentCalRate",
      pdenSource: PdenSourceEnum.Public.toString()
    },
    lockUnits: false,
    movingAverageDays: null,
    stackedBarCalculation: CalculationMethod.Average
  };

export const DEFAULT_TREND_DATE_MIDSTREAM_REQUEST: Partial<TrendDateChartRequestType> = {
  ...BASE_CHART_REQUEST,
  FilterId: "",
  requestId: "",
  ReverseColor: false,
  ColorPalette: {
    id: "-6",
    name: "Portland",
    shared: false,
    colors: ["rgb(12,51,131)"],
    preferredColors: [],
    paletteType: 0,
    colorScale: [],
    specialColors: null,
    thickness: [2],
    reverse: false
  },
  GroupBy: {
    title: "Facility Operator",
    property: "Header.OperatorName",
    groupByField: "Header.OperatorName",
    pdenSource: EvaSource.Public,
    canBin: false,
    dataType: "Text",
    categoryId: 1,
    tooltip: "",
    display: "",
    entityKind: EntityKind.Facility,
    bin: {
      BinSize: 0,
      MinSize: null,
      MaxBins: null,
      MaxBinsSortOrder: MaxBinsSortOrderEnum.WellCount,
      GreaterThan: null,
      LessThan: null,
      Quantile: {
        quantileType: "NumberOfQuantile",
        numQuantiles: 4
      },
      BinType: "BinSize",
      UseDynamicBins: false
    },
    mode: undefined,
    forecastTrumpingSettings: undefined,
    performanceDateRange: undefined
  },
  sortBy: "AlphabeticalAsc",
  normalizeTypeWell: true,
  userForecast: [],
  userForecastSettings: {
    forecastSourceFolder: null,
    excludeMcDanielForecasts: false,
    reserveCategory: null,
    excludeNoviForecasts: true,
    specialForecastFolders: ["McDaniel Research"]
  },
  forecastMode: "forecastTrump",
  useForecastStartDate: false,
  showGroupsNotInFilter: true,
  placeholderBinsEnabled: false,
  hasCheckedBins: true,
  syncClientPden: false,
  syncClientSchema: "",
  colorLockedItems: {},
  syncClientFcst: false,
  syncForecastRescat: "2111",
  normalizeBySetting: DEFAULT_NORMALIZE_BY_SETTING,
  chartSetting: DEFAULT_TREND_DATE_MIDSTREAM_CHART_SETTINGS as TrendDateChartSettings,
  axisMinMax: {
    xMin: null,
    xMax: null,
    yMin: null,
    yMax: null
  },
  isDefaultLockOn: true,
  chartFieldInformation: {
    xField: {
      type: "x",
      title: "Start Date (Year-Month)",
      property: "Header.FacilityStartDate_YearMonth",
      performanceDateRange: undefined
    },
    yField: {
      type: "y",
      title: "Current Cal. Rate (Mcf/d)",
      property: "Performance.Gas.CurrentCalRate",
      defaultUnit: "Mcf",
      product: "Gas",
      performanceDateRange: undefined
    },
    groupByField: {
      type: "groupBy",
      title: "Facility Operator",
      property: "Header.OperatorName",
      performanceDateRange: undefined
    }
  }
};

export const generateTrendDateMidstreamRequestBody = createMergeWithDefaults(
  DEFAULT_TREND_DATE_MIDSTREAM_REQUEST
);
